import globalConstant from './constants';



const getUserRole = (user: IUserDetails): string | undefined => {
    return user?.roles?.find(roleObj => roleObj.component === globalConstant.ORCA)?.role
}

export default getUserRole;
